import { z } from 'zod';
/** Ai demo-data slice — the entity-like inputs of the AI Insights view (SDD §7.4: insights, accounts, armed strategies, equity).
 *  Transcribed from the design reference aiModel() (script lines 1475–1635). Every field is deterministic, seeded and labeled simulated. */
export const AiInsightSchema = z
  .object({
    title: z.string(),
    sev: z.enum(['info', 'warning']),
    when: z.string(),
    unread: z.boolean(),
    body: z.string(),
    refs: z.array(z.string()),
  })
  .strict();
export const AiDataSchema = z
  .object({
    /** Current equity the period's net P&L is measured against (growth = net / (equity − net)). */
    equity: z.number(),
    /** Armed playbook strategies — entries tagged outside this list are off-plan. */
    playbook: z.array(z.string()),
    /** Account filter chips: [id, label]; 'all' is the unfiltered scope. */
    accounts: z.array(z.tuple([z.string(), z.string()])),
    /** Saved insights, newest first. */
    insights: z.array(AiInsightSchema),
  })
  .strict();
export type AiInsight = z.infer<typeof AiInsightSchema>;
export type AiData = z.infer<typeof AiDataSchema>;
